import {Plugins, Component} from '@packages/systems/wfdl';
import {generateGuid, incrementGuid} from '@packages/utilities/guid';
import {qualify} from '@packages/systems/wfdl-Qualified';
import {
  type Expression,
  ERecord,
  EElement,
  EText,
  EList,
} from '@packages/systems/wfdl-ast';

type ElementContent = {text: string; existingId: string | false};
const NON_BREAKING_SPACE = ' ';
const replaceAllSpaces = (spaces: string) =>
  spaces.replace(/ /g, NON_BREAKING_SPACE);
const stringType = qualify(Plugins.name('Basic'), Component.name('String'));
const lineBreakType = qualify(
  Plugins.name('Basic'),
  Component.name('LineBreak')
);

export const getListOfElementsFromString = ({
  text,
  existingId,
}: ElementContent) => {
  // Here we replace some spaces with non-breaking spaces
  const chunks = text
    // Case 1: Whenever we have more than one space in a row, we need them to be
    // non-breaking spaces:
    .replace(/  +/g, replaceAllSpaces)
    // Case 2: Whenever we have a space at the beginning of a line, we need it
    // to be a non-breaking space:
    //
    // NOTE: Order of these matter! If we were to run this replacement first,
    // the first two spaces of a line will not be reflected as non-breaking.
    .replace(/^ /g, NON_BREAKING_SPACE)
    .replace(/\n /g, '\n' + NON_BREAKING_SPACE)
    .split('\n');
  // We are preventing the loss of localized
  // text occurring after editing a text from the
  // settings panel at least for plain text, the trick
  // is to keep the old id of the text node
  // instead of getting a new one
  let currentId =
    chunks.length === 1 && existingId ? existingId : generateGuid();
  const result: Array<Expression> = [];
  for (let i = 0; i < chunks.length; i += 1) {
    const value = chunks[i];
    if (value !== '') {
      result.push(
        EElement({
          // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
          data: EText(value),
          type: stringType,
          id: currentId,
        })
      );
      currentId = incrementGuid(currentId);
    }

    if (i !== chunks.length - 1) {
      result.push(
        EElement({
          data: ERecord({}),
          type: lineBreakType,
          id: currentId,
        })
      );
      currentId = incrementGuid(currentId);
    }
  }

  return EList(result);
};
